import gql from "graphql-tag";

const queryCreatePosition = gql`
  mutation($name: String!, $status: String) {
    createPosition(data: { name: $name, status: $status }) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

const queryUpdatePosition = gql`
  mutation($name: String, $status: String, $id: ID!) {
    updatePosition(id: $id, data: { name: $name, status: $status }) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

const queryDeletePosition = gql`
  mutation($id: ID!) {
    deletePosition(id: $id) {
      id
    }
  }
`;

export default {
  queryCreatePosition,
  queryUpdatePosition,
  queryDeletePosition,
};
